module.exports = __webpack_public_path__ + "img/weibo.41b979bf.png";